import { getConfigBaseUrl, getConfigGraphBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk, graphqlCall } from '../../../utils/api';
import { getAllClientsQuery, getAllFundQuery } from './myFundQueries';
import { print } from 'graphql';

export const saveMyFundsThunk = createApiThunk('SAVE_MY_FUNDS', apiCall);
export const editMyFundsThunk = createApiThunk('EDIT_MY_FUNDS', apiCall);
export const deleteFundThunk = createApiThunk('DELETE_MY_FUND', apiCall);
export const getFundThunk = createApiThunk('GET_ALL_FUND', graphqlCall);
export const getAllClientsThunk = createApiThunk('GET_ALL_CLIENTS', graphqlCall);

export const saveMyFunds = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/fund/client`;
  return dispatch(saveMyFundsThunk({ url, method: 'POST', data }));
};

export const editMyFunds = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/fund/client`;
  return dispatch(editMyFundsThunk({ url, method: 'PUT', data }));
};

export const getFund = () => {
  const query = print(getAllFundQuery());
  const baseURL = getConfigGraphBaseUrl();
  return function (dispatch: AppDispatch) {
    dispatch(getFundThunk({ url: baseURL, query }));
  };
};

export const getAllClients = () => (dispatch: AppDispatch) => {
  const url = getConfigGraphBaseUrl();
  const query = print(getAllClientsQuery());
  return dispatch(getAllClientsThunk({ url, query }));
};

export const deleteFund = (fundId: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/fund/${fundId}`;
  const method = 'DELETE';
  return dispatch(deleteFundThunk({ url, method }));
};
